import React from 'react';
import { ProgressBar } from 'src/components/common/components/ProgressBar/ProgressBar';

interface CreditProgressBarProps {
  progress: number;
}

const PROGRESS_BAR_HEIGHT = 12;
const PROGRESS_BAR_BORDER_RADIUS = 50;

export function CreditProgressBar({
  progress,
}: CreditProgressBarProps): JSX.Element {
  return (
    <ProgressBar
      progress={progress}
      height={PROGRESS_BAR_HEIGHT}
      borderRadius={PROGRESS_BAR_BORDER_RADIUS}
      fillColor="colorCelebration"
      transitionDuration={400}
    />
  );
}
